import { render } from "./ecosystem.vue?vue&type=template&id=1bbc0e21"
import script from "./ecosystem.vue?vue&type=script&lang=js"
export * from "./ecosystem.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__